import { render, staticRenderFns } from "./qualification.vue?vue&type=template&id=727fe27e&scoped=true&"
import script from "./qualification.vue?vue&type=script&lang=js&"
export * from "./qualification.vue?vue&type=script&lang=js&"
import style0 from "./qualification.vue?vue&type=style&index=0&id=727fe27e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727fe27e",
  null
  
)

export default component.exports